import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Auto-reload on Vite chunk loading errors (happens after new deployments)
        if (error && error.message && error.message.includes('Failed to fetch dynamically imported module')) {
            const lastReload = sessionStorage.getItem('chunk_reload_time');
            const now = Date.now();
            
            // Only reload if we haven't tried in the last 10 seconds (prevents infinite loops)
            if (!lastReload || now - parseInt(lastReload) > 10000) {
                sessionStorage.setItem('chunk_reload_time', now.toString());
                window.location.reload();
            }
        }
        
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '2rem', color: '#ff5555', backgroundColor: '#1a1a1a', height: '100vh' }}>
                    <h1>Something went wrong.</h1>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                    <button onClick={() => window.location.reload()} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
